export const imageLoader = params => {
    const loaderState = [];
    const checker = () => {
        if (loaderState.filter(state => state !== undefined).length === params.sources.length) {
            const loaderSources = {
                items: loaderState,
                allLoad:
                    loaderState.filter(img => img.loaded === true).length === params.sources.length,
            };
            if (params.onloadAll) {
                params.onloadAll(loaderSources);
            }
        }
    };
    params.sources.forEach((src, i) => {
        const handler = e => {
            loaderState[i] = { src, loaded: e.type === 'load', index: i };
            if (params.onload) {
                params.onload(loaderState[i]);
            }
            checker();
        };
        const loadImg = new Image();
        loadImg.src = src;
        loadImg.addEventListener('load', handler);
        loadImg.addEventListener('error', handler);
    });
};
